// Swiper
// import Swiper, { Navigation, Pagination, Lazy } from "swiper";

// LightGallery
import lightGallery from "lightgallery";

// Plugins
import lgZoom from "lightgallery/plugins/zoom";

// Страница загрузилась
document.addEventListener("DOMContentLoaded", () => {
  const productSection = document.querySelector(".js-product-section");

  // Если мы на старнице товара
  if (productSection) {
    // Get Slider Wrapper
    const productSliderWrapper = document.getElementById(
      "product-slider-wrapper"
    );

    // Get add to cart button
    const addToCartButton = document.querySelector(
      ".single_add_to_cart_button"
    );
    const addToCartWrapper = document.querySelector(
      ".product-add-to-cart-wrapper"
    );

    const socialsWidget = document.querySelector(".socials-widget");

    // const addToCartOffsetTop =
    //   addToCartButton.offsetTop - addToCartButton.clientHeight;

    // Если существует обёртка
    if (productSliderWrapper) {
      // Инициализируем LightGallery
      lightGallery(productSliderWrapper, {
        plugins: [lgZoom],
        speed: 500,
        fullscreenPluginStrings: {
          toggleFullscreen: "Полноэкранный режим",
        },
      });
    }

    // breakpoint where swiper will be destroyed
    // and switches to a dual-column layout
    const breakpoint = window.matchMedia("(min-width:576px)");

    // keep track of swiper instances to destroy later
    let productSlider;
    let productObserver;

    const breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches === true) {
        // clean up old instances and inline styles when available
        if (productSlider !== undefined) productSlider.destroy();

        // Создаём наблюдатель за кнопкой добавить в корзину
        createObserver();

        // Если существует Кнопка добавить в корзину
        if (addToCartButton) productObserver.observe(addToCartButton);

        // or/and do nothing
        return;
        // else if a small viewport and single column layout needed
      } else if (breakpoint.matches === false) {
        // fire small viewport version of swiper
        enableSwiper();

        if (productObserver !== undefined) {
          productObserver.unobserve(addToCartButton);
          productObserver = undefined;
        }

        // Фиксируем кнопку после прокрутки
        fixAddToCardButton();
        window.addEventListener("scroll", fixAddToCardButton);

        // or/and do nothing
        return;
      }
    };

    const enableSwiper = function () {
      // Получаем изображения товара
      const slides = document.querySelectorAll(".product-slider__slide");

      // Если слайдов больше одного
      if (slides.length > 1) {
        productSlider = new Swiper(".product-slider", {
          loop: true,
          spaceBetween: 10,
          slidesPerView: 1,

          // modules: [Navigation, Pagination, Lazy],

          navigation: {
            prevEl: ".product-slider__nav--prev",
            nextEl: ".product-slider__nav--next",
          },

          pagination: {
            el: ".product-slider__pagination",
            type: "bullets",
            bulletActiveClass: "product-pagination__bullet--current",
            bulletClass: "product-pagination__bullet button-reset",
            bulletElement: "button",
            clickable: true,
          },

          lazy: {
            loadPrevNext: true,
          },
        });
      }
    };

    const createObserver = function () {
      const productQuickAdd = document.querySelector(".product-quick-add");

      let prevRatio = 0.0;

      const handleIntersect = (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > prevRatio) {
            productQuickAdd.classList.remove("product-quick-add--visible");
          } else {
            productQuickAdd.classList.add("product-quick-add--visible");
          }

          prevRatio = entry.intersectionRatio;
        });
      };

      const observerOptions = {
        threshold: 0.0,
      };

      productObserver = new IntersectionObserver(
        handleIntersect,
        observerOptions
      );
    };

    const fixAddToCardButton = function () {
      const top = window.scrollY;
      const height = window.innerHeight;

      addToCartWrapper &&
        (top + height >
        addToCartWrapper.getBoundingClientRect().top +
          window.scrollY +
          addToCartWrapper.offsetHeight
          ? (addToCartButton.classList.add("fixed"),
            socialsWidget.classList.add("hide"))
          : (addToCartButton.classList.remove("fixed"),
            socialsWidget.classList.remove("hide")));
    };

    // keep an eye on viewport size changes
    breakpoint.addEventListener("change", breakpointChecker);

    // Проверка шарины экрана и создание слайдера
    breakpointChecker();
  }
});
